/**
 * @returns the target upgrade package for the origin package
 */
function getLuxLoyaltyTargetUpgradePackage(
  offer: App.Offer | undefined,
  originPackage: App.Package | undefined,
): App.Package | undefined {
  if (!originPackage?.luxLoyalty.targetUpgradePackageUniqueKey || !offer) return
  return offer.packages.find(p => p.uniqueKey === originPackage.luxLoyalty.targetUpgradePackageUniqueKey)
}

export default getLuxLoyaltyTargetUpgradePackage
